<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form
        ref="modalProgramForm"
        :model="modalProgramForm"
        label-width="80px"
      >
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              label="回收商"
              prop="serviceId"
            >
              <el-select
                style="width:100%"
                v-model="modalProgramForm.serviceId"
                filterable
              >
                <el-option
                  v-for="item in queryServiceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="IMEI">
              <el-input  clearable  v-model="modalProgramForm.imei"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
           <el-form-item label="状态">
              <el-select clearable v-model="modalProgramForm.status">
                  <el-option
                      v-for="item in statusOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2.5">
            <el-button type="primary" @click="getImeiList">查询</el-button>
            <el-button type="primary" @click="addImei">创建</el-button>
            <el-button type="primary" @click="deleteAllImeiSet">删除</el-button>
          </el-col>
           <el-col :span="3.6">
              <el-upload
                      style="display:inline"
                      action="aa"
                      :show-file-list="false"
                      :before-upload="importSendInfo">
                <el-button style="margin-left:10px" type="primary" v-loading="fullscreenLoading">批量导入</el-button>
                </el-upload>
           </el-col>
          <el-col :span="2" style="margin-top:10px">
            <a type="primary" @click="getImeiTemplete">导入模板下载</a>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column  type="selection"  width="55"> </el-table-column>
        <el-table-column prop="id" label="编号"> </el-table-column>
         <el-table-column
            prop="serviceName"
            label="回收商名称">
          </el-table-column>
        <el-table-column prop="modelId" label="机型ID"> </el-table-column>
        <el-table-column prop="modelCode" label="机型代码"> </el-table-column>
        <el-table-column prop="modelName" label="机型名称"> </el-table-column>
        <el-table-column prop="imei" label="IMEI"> </el-table-column>
        <el-table-column prop="quotePrice" label="销售金额"> </el-table-column>
        <el-table-column prop="price" label="回收金额"> </el-table-column>
        <el-table-column label="报价员" prop="defaultQuoteName">
            </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">已使用</span>
            <span v-else style="color: red;">未使用</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="editormodel(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button @click="deleteLinkage(scope.row.id)" type="text" size="small" style="color: gray;">删除</el-button> 
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      :title="dlgType === 'change' ? '编辑IEMI' : '添加IEMI'"
      :visible.sync="isDlg"
      width="700px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="editModalForm"
            :model="editModalForm"
            :rules="editorFormRules"
            label-width="120px"
          >
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input
                clearable
                v-model="editModalForm.id"
                :disabled="true"
              ></el-input>
            </el-form-item>

            <el-form-item label="回收商">
              <el-select clearable
                v-model="editModalForm.serviceId"
                filterable
                remote
                placeholder="请输入关键词"
                reserve-keyword>
                <el-option
                  v-for="item in queryServiceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            
             <el-form-item label="机型编码" prop="modelCode">
              <el-input clearable v-model="editModalForm.modelCode"></el-input>
            </el-form-item>
             <el-form-item label="机型名称" prop="modelName">
              <el-input clearable v-model="editModalForm.modelName"></el-input>
            </el-form-item>
            <el-form-item label="IMEI" prop="IMEI">
              <el-input clearable v-model="editModalForm.imei"></el-input>
            </el-form-item>
            <el-form-item label="销售金额" prop="quotePrice">
              <el-input clearable v-model="editModalForm.quotePrice"></el-input>
            </el-form-item>
             <el-form-item label="回收价格" prop="price">
              <el-input clearable v-model="editModalForm.price"></el-input>
            </el-form-item>
             <el-form-item label="默认报价员手机号" prop="defaultQuotePhone">
              <el-input clearable v-model="editModalForm.defaultQuotePhone"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-radio v-model="editModalForm.status" :label="0" >未使用</el-radio>
              <el-radio v-model="editModalForm.status" :label="1">已使用</el-radio>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditormodelDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // 查询数据
      modalProgramForm: {
        imei: "",
      },
      statusOptions:[{id:0,name:"未使用"},{id:1,name:"已使用"}],

      // 表格数据
      tableTotal: 0,
      tableData: [],
      typeKey: "sku_memory",
      pageSize: 10,
      currentPage: 1,
      queryServiceList:[],

      // 新建编辑对话框数据

      isDlg: false,
      editModalForm: {
        id: null,
        modelCode: null,
        modelName: null,
        imei: null,
        quotePrice: null,
        status: 0
      },

      editorFormRules: {
      },

      dlgType: "change",

      // 选择
      modelOptions: [],
      loading: false,

      categoryOptions: [],
      brandOptions: [],
      dlgBrandOptions: [],
      fullscreenLoading:false,
       multipleSelection: []
    };
  },
  watch: {},
  computed: {},
  methods: {
      //回收商集合
     getServiceList() {
      let self = this;
      this.$api.getValidHjxServiceProvider().then((res) => {
        self.queryServiceList = res.data || [];
      });
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    deleteAllImeiSet(){
      let self = this
        self.$confirm('是否全部删除').then(() => {
           self.$api.deleteByIds(self.multipleSelection).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getImeiList()
          }
      })
    })
    },
    deleteLinkage(id){
      let self = this
        self.$confirm('是否删除').then(() => {
           self.$api.deleteImeiSet({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getImeiList()
          }
      })
      })
   
    },
     // 批量导入
    importSendInfo(file) {
      this.fullscreenLoading = true
      let formData = new FormData()
      formData.append('file', file)
      this.$api.importImei(formData).then(res => {
        this.fullscreenLoading  = false
        if(res.code === 200) {
          this.$message({
            message: '导入成功',
            type: 'success'
          });
          this.getImeiList()
        }
      })
      return false;
    },
    getImeiTemplete(){
      window.open(`/api/hjx/tailiImeiSet/getImeiTemplete`,"_blank")
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getImeiList();
    },

    // 获取表格数据
    getImeiList() {
      let self = this;
      console.log(self.modalProgramForm.status)
      self.$api
        .listSearchImeiSet({
          page: self.currentPage,
          size: self.pageSize,
          imei: self.modalProgramForm.imei || null,
          status:self.modalProgramForm.status
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addImei() {
      this.dlgType = "new";
      this.editModalForm=this.$options.data().editModalForm;
      this.$nextTick(()=>{
          this.$refs['editModalForm'].clearValidate()
      })
      this.isDlg = true;
    },

    // 修改
    editormodel(row) {
      let self = this;
      self.editModalForm = {
        id: null,
        modelCode: null,
        modelName: null,
        imei: null,
        quotePrice: null,
        price:null,
        serviceId:null,
        defaultQuotePhone:null,
        status: 0
      };
      self.dlgType = "change";
      for (let i in self.editModalForm) {
          if (row[i]) self.editModalForm[i] = row[i];
      }
      self.isDlg = true;
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editModalForm"].validate((valid) => {
        if (valid) {
          let params = {};
          for (let i in self.editModalForm) {
            params[i] = this.editModalForm[i];
          }
          if (self.dlgType === "change") {
            self.$api.updateImeiSet({id:self.editModalForm.id,
              imei:self.editModalForm.imei,
              modelCode:self.editModalForm.modelCode,
              modelName:self.editModalForm.modelName,
              quotePrice:self.editModalForm.quotePrice,
              price:self.editModalForm.price,
              serviceId:self.editModalForm.serviceId,
              defaultQuotePhone:self.editModalForm.defaultQuotePhone,
              status:self.editModalForm.status}).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                self.getImeiList();
                self.closeEditormodelDlg();
              }
            });
          } else {
            self.$api.addImeiSet({
              imei:self.editModalForm.imei,
              modelCode:self.editModalForm.modelCode,
              modelName:self.editModalForm.modelName,
              quotePrice:self.editModalForm.quotePrice,
              price:self.editModalForm.price,
              defaultQuotePhone:self.editModalForm.defaultQuotePhone,
               serviceId:self.editModalForm.serviceId,
              status:self.editModalForm.status}).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                self.getImeiList();
                self.closeEditormodelDlg();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    
  },
  created() {},
  mounted() {
    let self = this;
    self.getImeiList();
    self.getServiceList();
  },
};
</script>
<style lang="less" scoped></style>
